<template>
    <svg class="text-[#354E8B] fill-current" viewBox="0 0 41 40" xmlns="http://www.w3.org/2000/svg">
        <g id="0-Style-Guide" stroke="none" stroke-width="1" fill-rule="evenodd">
            <g id="Style-Guide" transform="translate(-204.000000, -3437.000000)">
                <path d="M237,3437 L212,3437 C207.8575,3437 204.5,3440.3575 204.5,3444.5 L204.5,3469.5 C204.5,3473.6425 207.8575,3477 212,3477 L237,3477 C241.1425,3477 244.5,3473.6425 244.5,3469.5 L244.5,3444.5 C244.5,3440.3575 241.1425,3437 237,3437 L237,3437 Z M229.67,3456.9975 L226.3925,3457 L226.39,3469 L221.8925,3469 L221.8925,3457 L218.8925,3457 L218.8925,3452.865 L221.8925,3452.8625 L221.8875,3450.4275 C221.8875,3447.0525 222.8025,3445 226.775,3445 L230.085,3445 L230.085,3449.1375 L228.015,3449.1375 C226.4675,3449.1375 226.3925,3449.715 226.3925,3450.7925 L226.3875,3452.8625 L230.1075,3452.8625 L229.67,3456.9975 L229.67,3456.9975 Z" id="facebook-icon"></path>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconFacebook"
}
</script>
